<template>
	<div>
		<Form ref="form" :model="data" :label-width="85" label-position="right">
			<Row type="flex" justify="center" align="middle">
				<Col :span="10">
				<FormItem label="菜单名称：" prop="menuName" label-for="menuName">
					<Input v-model="data.menuName" placeholder="请输入" element-id="menuName" />
				</FormItem>
				</Col>
				<Col :span="6" class="ivu-text-right">
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
					<Button @click="handleReset('form')" style="margin-left: 20px">重置</Button>
				</FormItem>
				</Col>
			</Row>
		</Form>

		<Table row-key="menuId" :columns="columns1" :data="data1" :indent-size="50" border>
			<template slot="action" slot-scope="{ row, index }">
				<Button type="info" ghost size="small" style="margin-right: 5px" @click="menuEditMain(row)">编辑</Button>
				<Button type="error" ghost size="small" style="margin-right: 5px"
					@click="menuDeleteMain(row)">删除</Button>
				<Button type="success" ghost size="small" style="margin-right: 5px" @click="menuMainAdd(row)">添加</Button>
			</template>

		</Table>



		<div>
			<Modal v-model="modal1" title="菜单新增" width="20%" :loading="submitting" @on-ok="menuMainAddFunc()">
				<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
					<FormItem label="上级菜单名称：" prop="parentMenuName">
						<Input v-model="modalformValidata.parentMenuName" disabled />
					</FormItem>
					<FormItem label="菜单名称：" prop="menuName">
						<Input v-model="modalformValidata.menuName" />
					</FormItem>
					<FormItem label="菜单路径：" prop="menuLocation">
						<Input v-model="modalformValidata.menuLocation" />
					</FormItem>
					<FormItem label="菜单图标：" prop="menuIcon">
						<Input v-model="modalformValidata.menuIcon" />
					</FormItem>

					<RadioGroup v-model="modalformValidata.menuType">
						<Radio label="0">
							<span>目录</span>
						</Radio>
						<Radio label="1">
							<span>菜单</span>
						</Radio>
					</RadioGroup>
					<FormItem label="菜单展现顺序" prop="menuOrdinal">
						<Input v-model="modalformValidata.menuOrdinal" placeholder="请输入正整数"
							@on-keyup="intCheck(modalformValidata.menuOrdinal)"></Input>
					</FormItem>
				</Form>
			</Modal>
		</div>
		<div>
			<Modal v-model="modal2" title="菜单编辑" width="20%" :loading="submitting" @on-ok="menuEditFunc()">
				<Form ref="modalformValidata" :model="modalformValidata" :rules="ruleValidate">
					<FormItem label="菜单id：" prop="menuId">
						<Input v-model="modalformValidata.menuId" disabled />
					</FormItem>
					<FormItem label="菜单名称：" prop="menuName">
						<Input v-model="modalformValidata.menuName" />
					</FormItem>
					<FormItem label="菜单路径：" prop="menuLocation">
						<Input v-model="modalformValidata.menuLocation" />
					</FormItem>
					<FormItem label="菜单图标：" prop="menuIcon">
						<Input v-model="modalformValidata.menuIcon" />
					</FormItem>

					<RadioGroup v-model="modalformValidata.menuType">
						<Radio label="0">
							<span>目录</span>
						</Radio>
						<Radio label="1">
							<span>菜单</span>
						</Radio>
					</RadioGroup>
					<FormItem label="菜单展现顺序" prop="menuOrdinal">
						<Input v-model="modalformValidata.menuOrdinal" placeholder="请输入正整数"
							@on-keyup="intCheck(modalformValidata.menuOrdinal)"></Input>
					</FormItem>
				</Form>
			</Modal>
		</div>

	</div>
</template>
<script>
	const paramter = {
		menuName: null,
	};
	import {
		getMenuTreer,
		menuGet,
		menuAdd,
		menuEdit,
		menuDelete,
		getDeptTreer
	} from '@/network/index.js';


	export default {
		components: {

		},
		data() {
			return {
				columns1: [{
						title: '菜单id',
						key: 'menuId',
						width: 250,
						tree: true
					},
					{

						title: '菜单名称',
						key: 'menuName',
					},
					{
						title: '菜单类型',
						key: 'menuTypeName',
						width: 140,
					},
					{
						title: '菜单路径',
						key: 'menuLocation',
					},
					{
						title: '菜单图标',
						key: 'menuIcon',
					},
					{
						title: '菜单顺序',
						key: 'menuOrdinal',
						width: 100,
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center',
						fixed: 'right',
					},


				],

				data1: [],
				modal1: false,
				modal2: false,
				submitting: true,
				modalformValidata: {
					menuId: '',
					parentMenuId: '',
					parentMenuNameName: '',
					menuType: '1',
					menuLocation: '',
					menuName: '',
					menuOrdinal: '',
					menuIcon: '',
				},
				//如下是查询条件的
				grid: {
					xl: 8,
					lg: 8,
					md: 12,
					sm: 24,
					xs: 24
				},
				data: {
					menuName: null,
				},
				ruleValidate: {
					menuName: [{
						required: true,
						message: '菜单名称必须填写',
						trigger: 'blur'
					}],
					menuLocation: [{
						required: true,
						message: '菜单路径必须填写',
						trigger: 'blur'
					}],
					menuType: [{
						required: true,
						message: '菜单类型必须填写',
						trigger: 'blur'
					}],
				}

			}
		},
		created() {
			this.initData();
		},
		computed: {},
		methods: {
			//初始化用户信息 
			initData(paramter) {
				getMenuTreer(paramter).then(res => {
						//数据清空
						this.data1 = [];
						this.data1.push({
							menuId: res.data.obj.menuId,
							menuName: res.data.obj.menuName,
							menuType: res.data.obj.menuType,
							menuTypeName: res.data.obj.menuTypeName,
							menuLocation: res.data.obj.menuLocation,
							menuIcon: res.data.obj.menuIcon,
							parentMenuId: res.data.obj.parentMenuId,
							menuLevel: res.data.obj.menuLevel,
							menuOrdinal:res.data.obj.menuOrdinal,  
							children: res.data.obj.children,
							_showChildren: true,
						});
						 
				})
			.catch(error => {
				console.log(error)
			});
		 
		},



		//菜单新增 弹出模态框
		menuMainAdd(row) {
			this.modal1 = true;
			let menuId = row.menuId;

			this.modalformValidata.parentMenuId = menuId;
			//获取父菜单的名称
			menuGet(menuId, paramter).then(res => {
					this.modalformValidata.parentMenuName = res.data.obj.menuName;
				})
				.catch(error => {
					console.log(error)
				});
		},



		//菜单新增
		menuMainAddFunc() {
			let paramter = {
				menuName: this.modalformValidata.menuName,
				parentMenuId: this.modalformValidata.parentMenuId,
				menuIcon: this.modalformValidata.menuIcon,
				menuLocation: this.modalformValidata.menuLocation,
				menuType: this.modalformValidata.menuType,
				menuOrdinal: this.modalformValidata.menuOrdinal,
			};

			//debugger;
			menuAdd(paramter).then(res => {
					if (res.success == true) {
						this.$Message.success('菜单添加成功!');
						this.modal1 = false;

						this.selectMenuTree(paramter.parentMenuId);
					} else {
						//console.log('res.message:' + res.message);
						this.$Message.error(res.message);
					}
				})
				.catch(error => {
					this.$Message.success('菜单添加失败，请联系管理员!');
				});
		},

		//菜单编辑 弹出模态框
		menuEditMain(row) {
			this.modal2 = true;
			this.modalformValidata.menuId = row.menuId;
			this.modalformValidata.menuName = row.menuName;
			this.modalformValidata.menuIcon = row.menuIcon;
			this.modalformValidata.menuLocation = row.menuLocation;
			this.modalformValidata.menuType = row.menuType;
			this.modalformValidata.menuOrdinal = row.menuOrdinal;
			this.modalformValidata.parentMenuId = row.parentMenuId;
           // console.log('row.menuOrdinal:'+row.menuOrdinal)
		},
		//菜单编辑
		menuEditFunc() {
			let paramter = {
				menuName: this.modalformValidata.menuName,
				menuIcon: this.modalformValidata.menuIcon,
				menuLocation: this.modalformValidata.menuLocation,
				menuType: this.modalformValidata.menuType,
				menuOrdinal: this.modalformValidata.menuOrdinal,
				parentMenuId:this.modalformValidata.parentMenuId
			};

			menuEdit(this.modalformValidata.menuId, paramter).then(res => {
					if (res.success == true) {
						this.$Message.success('菜单修改成功!');
						this.modal2 = false;

						this.selectMenuTree(paramter.parentMenuId);
					} else {
						//console.log('res.message:' + res.message);
						this.$Message.error(res.message);
					}
				})
				.catch(error => {
					this.$Message.success('菜单修改失败，请联系管理员!');
				});
		},

		//删除菜单树
		menuDeleteMain(row) {
			menuDelete(row.menuId, null).then(res => {
					if (res.success == true) {
						this.$Message.success('菜单删除成功!');
						this.selectMenuTree(row.parentMenuId);
					} else {
						//console.log('res.message:' + res.message);
						this.$Message.error(res.message);
					}
				})
				.catch(error => {
					this.$Message.success('菜单删除失败，请联系管理员!');
				});
		},

		//查询菜单树
		selectMenuTree(parentMenuId) {
			getMenuTreer().then(res => {
					//数据清空
					this.data1 = [];
					this.data1.push({
						menuId: res.data.obj.menuId,
						menuName: res.data.obj.menuName,
						menuType: res.data.obj.menuType,
						menuTypeName: res.data.obj.menuTypeName,
						menuLocation: res.data.obj.menuLocation,
						menuIcon: res.data.obj.menuIcon,
						parentMenuId: res.data.obj.parentMenuId,
						menuLevel: res.data.obj.menuLevel,
						children: res.data.obj.children,
						_showChildren: true,
					});
					this.openTree(parentMenuId, this.data1);

				})
				.catch(error => {
					console.log(error)
				});
		},

		//指定级别打开树   
		openTree(pMenuId, item) {
			//debugger;
			let temp = this.data1;
			//console.log('item.length:' + item.length);
			for (var i = 0; i < item.length; i++) {
				let menuId = item[i].menuId;
				if (menuId == pMenuId) {
					//给对象增加属性的方法
					//this.$set(target, key, value)
					//target: 要更改的数据源（可以使对象或者数组）
					//key: 要更改的属性
					//value: 赋给该属性的值
					this.$set(item[i], '_showChildren', true);
					//console.log('dfd:' + item[i].parentMenuId);
					//展开父级菜单  根目录查询的时候就已经是展开的
					if (item[i].parentMenuId != null) {
						this.openTree(item[i].parentMenuId, this.data1);
					}
				} else {
					let childrenList = item[i].children;
					if (item[i].children == null) {
						//console.log('quit!');
					} else {
						this.openTree(pMenuId, childrenList);
					}
				}
			}
		},

		//查询提交
		handleSubmit() {
			let paramter = {
				menuName: this.data.menuName,
			};
			this.initData(paramter);
		},
		//重置
		handleReset(name) {
			this.$refs[name].resetFields();
		},
		//检查输入的是否是正整数
		intCheck() {
			this.modalformValidata.menuOrdinal = this.modalformValidata.menuOrdinal.replace(/\D/g, '')
		},




	},



	}
</script>

<style lang="scss" scoped>
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}
</style>
